{
  "about.blocks": "Մոդերացուող սպասարկիչներ",
  "about.contact": "Կապ՝",
  "about.disclaimer": "Մաստոդոնը ազատ, բաց ելակոդով ծրագրակազմ է, յայտնի Mastodon gGmbH ապրանքանշանով։",
  "about.domain_blocks.silenced.title": "Սահմանափակ",
  "about.domain_blocks.suspended.title": "Սպասող",
  "about.not_available": "Այս տեղեկութիւնը տեսանելի չի այս սերուերում։",
  "about.powered_by": "Ապակենտրոն սոց. ցանց սեղծուած {mastodon}-ով։",
  "about.rules": "Սերուերի կանոնները",
  "account.add_or_remove_from_list": "Աւելացնել կամ հեռացնել ցանկերից",
  "account.badges.bot": "Բոտ",
  "account.badges.group": "Խումբ",
  "account.block": "Արգելափակել @{name}֊ին",
  "account.block_domain": "Թաքցնել ամէնը հետեւեալ տիրոյթից՝ {domain}",
  "account.block_short": "Արգելափակել",
  "account.blocked": "Արգելափակուած է",
  "account.cancel_follow_request": "Withdraw follow request",
  "account.direct": "Մասնաւոր յիշատակում @{name}",
  "account.disable_notifications": "Ծանուցումները անջատել @{name} գրառումների համար",
  "account.edit_profile": "Խմբագրել հաշիւը",
  "account.enable_notifications": "Ծանուցել ինձ @{name} գրառումների մասին",
  "account.endorse": "Ցուցադրել անձնական էջում",
  "account.follow": "Հետեւել",
  "account.followers": "Հետեւողներ",
  "account.followers.empty": "Այս օգտատիրոջը դեռ ոչ մէկ չի հետեւում։",
  "account.following": "Հետեւած",
  "account.follows.empty": "Այս օգտատէրը դեռ ոչ մէկի չի հետեւում։",
  "account.go_to_profile": "Գնալ անձնական հաշիւ",
  "account.hide_reblogs": "Թաքցնել @{name}֊ի տարածածները",
  "account.joined_short": "Միացել է",
  "account.link_verified_on": "Սոյն յղման տիրապետումը ստուգուած է՝ {date}֊ին",
  "account.locked_info": "Սոյն հաշուի գաղտնիութեան մակարդակը նշուած է որպէս՝ փակ։ Հաշուի տէրն ընտրում է, թէ ով կարող է հետեւել իրեն։",
  "account.media": "Մեդիա",
  "account.mention": "Նշել @{name}֊ին",
  "account.mute": "Լռեցնել @{name}֊ին",
  "account.mute_notifications_short": "Անջատել ծանուցումները",
  "account.mute_short": "Լռեցնել",
  "account.muted": "Լռեցուած",
  "account.no_bio": "Նկարագրութիւն չկայ:",
  "account.open_original_page": "Բացել իրական էջը",
  "account.posts": "Գրառումներ",
  "account.report": "Բողոքել @{name}֊ի մասին",
  "account.requested_follow": "{name}-ը ցանկանում է հետեւել քեզ",
  "account.share": "Կիսուել @{name}֊ի էջով",
  "account.show_reblogs": "Ցուցադրել @{name}֊ի տարածածները",
  "account.unblock": "Ապաարգելափակել @{name}֊ին",
  "account.unblock_domain": "Ցուցադրել {domain} թաքցուած տիրոյթի գրառումները",
  "account.unblock_short": "Արգելաբացել",
  "account.unendorse": "Չցուցադրել անձնական էջում",
  "account.unfollow": "Ապահետեւել",
  "account.unmute": "Ապալռեցնել @{name}֊ին",
  "account.unmute_short": "Ապախլացնել",
  "account_note.placeholder": "Սեղմէ՛ք գրառելու համար\n",
  "admin.dashboard.retention.average": "Միջին",
  "admin.dashboard.retention.cohort": "Ամսուայ գրանցումներ",
  "admin.dashboard.retention.cohort_size": "Նոր օգտուող",
  "alert.rate_limited.message": "Փորձէք  որոշ ժամանակ անց՝ {retry_time, time, medium}։",
  "alert.rate_limited.title": "Գործողութիւնների յաճախութիւնը գերազանցում է թոյլատրելին",
  "alert.unexpected.message": "Անսպասելի սխալ տեղի ունեցաւ։",
  "alert.unexpected.title": "Վա՜յ",
  "announcement.announcement": "Յայտարարութիւններ",
  "audio.hide": "Թաքցնել աուդիոն",
  "boost_modal.combo": "Կարող ես սեղմել {combo}՝ սա յաջորդ անգամ բաց թողնելու համար",
  "bundle_column_error.error.title": "Օ՜, ոչ։",
  "bundle_column_error.network.title": "Ցանցի սխալ",
  "bundle_column_error.retry": "Կրկին փորձել",
  "bundle_column_error.return": "Վերադառնալ տուն",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Փակել",
  "bundle_modal_error.retry": "Կրկին փորձել",
  "closed_registrations_modal.find_another_server": "Գտնել այլ սերուերում",
  "column.about": "Մասին",
  "column.blocks": "Արգելափակուած օգտատէրեր",
  "column.bookmarks": "Էջանիշեր",
  "column.community": "Տեղական հոսք",
  "column.direct": "Մասնաւոր յիշատակումներ",
  "column.directory": "Զննել անձնական էջերը",
  "column.domain_blocks": "Թաքցուած տիրոյթները",
  "column.favourites": "Հաւանածներ",
  "column.firehose": "Հոսքեր",
  "column.follow_requests": "Հետեւելու հայցեր",
  "column.home": "Հիմնական",
  "column.lists": "Ցանկեր",
  "column.mutes": "Լռեցրած օգտատէրեր",
  "column.notifications": "Ծանուցումներ",
  "column.pins": "Ամրացուած գրառում",
  "column.public": "Դաշնային հոսք",
  "column_back_button.label": "Ետ",
  "column_header.hide_settings": "Թաքցնել կարգաւորումները",
  "column_header.moveLeft_settings": "Տեղաշարժել սիւնը ձախ",
  "column_header.moveRight_settings": "Տեղաշարժել սիւնը աջ",
  "column_header.pin": "Ամրացնել",
  "column_header.show_settings": "Ցուցադրել կարգաւորումները",
  "column_header.unpin": "Հանել",
  "community.column_settings.local_only": "Միայն տեղական",
  "community.column_settings.media_only": "Միայն մեդիա",
  "community.column_settings.remote_only": "Միայն հեռակայ",
  "compose.language.change": "Փոխել լեզուն",
  "compose.language.search": "Որոնել լեզուներ",
  "compose.published.open": "Բացել",
  "compose_form.direct_message_warning_learn_more": "Իմանալ աւելին",
  "compose_form.encryption_warning": "Posts on Mastodon are not end-to-end encrypted. Do not share any dangerous information over Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Քո հաշիւը {locked} չէ։ Իւրաքանչիւրութիւն ոք կարող է հետեւել քեզ եւ տեսնել միայն հետեւողների համար նախատեսուած գրառումները։",
  "compose_form.lock_disclaimer.lock": "փակ",
  "compose_form.placeholder": "Ի՞նչ կայ մտքիդ",
  "compose_form.poll.duration": "Հարցման տեւողութիւնը",
  "compose_form.poll.switch_to_multiple": "Հարցումը դարձնել բազմակի ընտրութեամբ",
  "compose_form.poll.switch_to_single": "Հարցումը դարձնել եզակի ընտրութեամբ",
  "compose_form.spoiler.marked": "Տեքստը թաքցուած է զգուշացման ետեւում",
  "compose_form.spoiler.unmarked": "Տեքստը թաքցուած չէ",
  "confirmation_modal.cancel": "Չեղարկել",
  "confirmations.block.confirm": "Արգելափակել",
  "confirmations.delete.confirm": "Ջնջել",
  "confirmations.delete.message": "Վստա՞հ ես, որ ուզում ես ջնջել այս գրառումը։",
  "confirmations.delete_list.confirm": "Ջնջել",
  "confirmations.delete_list.message": "Վստա՞հ ես, որ ուզում ես մշտապէս ջնջել այս ցանկը։",
  "confirmations.discard_edit_media.confirm": "Չեղարկել",
  "confirmations.logout.confirm": "Ելք",
  "confirmations.logout.message": "Համոզո՞ւած ես, որ ուզում ես դուրս գալ",
  "confirmations.mute.confirm": "Լռեցնել",
  "confirmations.redraft.confirm": "Ջնջել եւ խմբագրել նորից",
  "confirmations.unfollow.confirm": "Ապահետեւել",
  "conversation.delete": "Ջնջել խօսակցութիւնը",
  "conversation.mark_as_read": "Նշել որպէս ընթերցուած",
  "conversation.open": "Դիտել խօսակցութիւնը",
  "conversation.with": "{names}-ի հետ",
  "copypaste.copied": "Պատճէնուած է",
  "directory.federated": "Յայտնի դաշնեզերքից",
  "directory.local": "{domain} տիրոյթից միայն",
  "directory.new_arrivals": "Նորեկներ",
  "directory.recently_active": "Վերջերս ակտիւ",
  "disabled_account_banner.account_settings": "Հաշուի կարգաւորումներ",
  "dismissable_banner.dismiss": "Բաց թողնել",
  "embed.instructions": "Այս գրառումը քո կայքում ներդնելու համար կարող ես պատճէնել ներքեւի կոդը։",
  "embed.preview": "Ահա, թէ ինչ տեսք կունենայ այն՝",
  "emoji_button.activity": "Զբաղմունքներ",
  "emoji_button.clear": "Մաքրել",
  "emoji_button.custom": "Յատուկ",
  "emoji_button.flags": "Դրօշներ",
  "emoji_button.food": "Կերուխում",
  "emoji_button.label": "Էմոջի աւելացնել",
  "emoji_button.nature": "Բնութիւն",
  "emoji_button.not_found": "Նման էմոջիներ դեռ չեն յայտնաբերուել։ (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Առարկաներ",
  "emoji_button.people": "Մարդիկ",
  "emoji_button.recent": "Յաճախ օգտագործուող",
  "emoji_button.search": "Որոնել…",
  "emoji_button.search_results": "Որոնման արդիւնքներ",
  "emoji_button.symbols": "Նշաններ",
  "emoji_button.travel": "Ուղեւորութիւն եւ տեղանքներ",
  "empty_column.account_suspended": "Հաշիւը արգելափակուած է",
  "empty_column.account_timeline": "Այստեղ գրառումներ չկա՛ն։",
  "empty_column.account_unavailable": "Անձնական էջը հասանելի չի",
  "empty_column.blocks": "Դու դեռ ոչ մէկի չես արգելափակել։",
  "empty_column.bookmarked_statuses": "Դու դեռ չունես որեւէ էջանշուած գրառում։ Երբ էջանշես, դրանք կը երեւան այստեղ։",
  "empty_column.community": "Տեղական հոսքը դատարկ է։ Հրապարակային մի բան գրի՛ր շարժիչը գործարկելու համար։",
  "empty_column.domain_blocks": "Թաքցուած տիրոյթներ դեռ չկան։",
  "empty_column.follow_requests": "Դու դեռ չունես որեւէ հետեւելու յայտ։ Բոլոր նման յայտերը կը յայտնուեն այստեղ։",
  "empty_column.hashtag": "Այս պիտակով դեռ ոչինչ չկայ։",
  "empty_column.home": "Քո հիմնական հոսքը դատարկ է։ Այցելի՛ր {public}ը կամ օգտուիր որոնումից՝ այլ մարդկանց հանդիպելու համար։",
  "empty_column.list": "Այս ցանկում դեռ ոչինչ չկայ։ Երբ ցանկի անդամներից որեւէ մէկը նոր գրառում անի, այն կը յայտնուի այստեղ։",
  "empty_column.mutes": "Առայժմ ոչ ոքի չէք լռեցրել։",
  "empty_column.notifications": "Ոչ մի ծանուցում դեռ չունես։ Բզիր միւսներին՝ խօսակցութիւնը սկսելու համար։",
  "empty_column.public": "Այստեղ բան չկա՛յ։ Հրապարակային մի բան գրիր կամ հետեւիր այլ հանգոյցներից էակների՝ այն լցնելու համար։",
  "error.unexpected_crash.explanation": "Մեր ծրագրակազմում վրիպակի կամ դիտարկչի անհամատեղելիութեան պատճառով այս էջը չի կարող լիարժէք պատկերուել։",
  "error.unexpected_crash.explanation_addons": "Այս էջի ճիշտ պատկերումը չի ստացում։ Խափանումը հաւանաբար առաջացել է դիտարկիչի յավելվածից կամ առցանց թարգմանիչից։",
  "error.unexpected_crash.next_steps": "Փորձիր թարմացնել էջը։ Եթէ դա չօգնի ապա կարող ես օգտուել Մաստադոնից ուրիշ դիտարկիչով կամ յաւելուածով։",
  "error.unexpected_crash.next_steps_addons": "Փորձիր անջատել յաւելուածները եւ թարմացնել էջը։ Եթե դա չօգնի, կարող ես օգտուել Մաստադոնից այլ դիտարկիչով կամ յաւելուածով։",
  "errors.unexpected_crash.copy_stacktrace": "Պատճենել սթաքթրեյսը սեղմատախտակին",
  "errors.unexpected_crash.report_issue": "Զեկուցել խնդրի մասին",
  "explore.suggested_follows": "Մարդիկ",
  "explore.trending_links": "Նորութիւններ",
  "explore.trending_statuses": "Գրառումներ",
  "explore.trending_tags": "Պիտակներ",
  "filter_modal.added.settings_link": "կարգաւորումների էջ",
  "filter_modal.select_filter.expired": "ժամկէտանց",
  "filter_modal.select_filter.prompt_new": "Նոր կատեգորիա՝ {name}",
  "filter_modal.select_filter.search": "Որոնել կամ ստեղծել",
  "filter_modal.select_filter.title": "Զտել այս գրառումը",
  "firehose.all": "Բոլորը",
  "firehose.local": "Այս հանգոյցը",
  "firehose.remote": "Այլ հանգոյցներ",
  "follow_request.authorize": "Վաւերացնել",
  "follow_request.reject": "Մերժել",
  "follow_requests.unlocked_explanation": "Այս հարցումը ուղարկուած է հաշուից, որի համար {domain}-ի անձնակազմը միացրել է ձեռքով ստուգում։",
  "followed_tags": "Հետեւած պիտակներ",
  "footer.about": "Մասին",
  "footer.directory": "Հաշիւների մատեան",
  "footer.get_app": "Ներբեռնիր յաւելուած",
  "footer.keyboard_shortcuts": "Ստեղնաշարի կարճատներ",
  "footer.privacy_policy": "Գաղտնիութեան քաղաքականութիւն",
  "footer.source_code": "Նայել ելակոդը",
  "footer.status": "Կարգավիճակ",
  "generic.saved": "Պահպանուած է",
  "getting_started.heading": "Ինչպէս սկսել",
  "hashtag.column_header.tag_mode.all": "եւ {additional}",
  "hashtag.column_header.tag_mode.any": "կամ {additional}",
  "hashtag.column_header.tag_mode.none": "առանց {additional}",
  "hashtag.column_settings.select.no_options_message": "Առաջարկներ չկան",
  "hashtag.column_settings.select.placeholder": "Աւելացրու պիտկներ…",
  "hashtag.column_settings.tag_mode.all": "Բոլորը",
  "hashtag.column_settings.tag_mode.any": "Ցանկացածը",
  "hashtag.column_settings.tag_mode.none": "Ոչ մեկը",
  "hashtag.column_settings.tag_toggle": "Ներառել լրացուցիչ պիտակները այս սիւնակում ",
  "hashtag.follow": "Հետեւել պիտակին",
  "hashtag.unfollow": "Չհետեւել պիտակին",
  "home.column_settings.show_reblogs": "Ցուցադրել տարածածները",
  "home.column_settings.show_replies": "Ցուցադրել պատասխանները",
  "home.hide_announcements": "Թաքցնել յայտարարութիւնները",
  "home.show_announcements": "Ցուցադրել յայտարարութիւնները",
  "interaction_modal.on_another_server": "Այլ հանգոյցում",
  "interaction_modal.on_this_server": "Այս հանգոյցում",
  "intervals.full.days": "{number, plural, one {# օր} other {# օր}}",
  "intervals.full.hours": "{number, plural, one {# ժամ} other {# ժամ}}",
  "intervals.full.minutes": "{number, plural, one {# րոպէ} other {# րոպէ}}",
  "keyboard_shortcuts.back": "ետ նաւարկելու համար",
  "keyboard_shortcuts.blocked": "արգելափակուած օգտատէրերի ցանկը բացելու համար",
  "keyboard_shortcuts.boost": "տարածելու համար",
  "keyboard_shortcuts.column": "սիւներից մէկի վրայ սեւեռուելու համար",
  "keyboard_shortcuts.compose": "շարադրման տիրոյթին սեւեռուելու համար",
  "keyboard_shortcuts.description": "Նկարագրութիւն",
  "keyboard_shortcuts.down": "ցանկով ներքեւ շարժուելու համար",
  "keyboard_shortcuts.enter": "Գրառումը բացելու համար",
  "keyboard_shortcuts.favourite": "Հաւանած գրառում",
  "keyboard_shortcuts.favourites": "Բացել հաւանածների ցուցակը",
  "keyboard_shortcuts.federated": "դաշնային հոսքին անցնելու համար",
  "keyboard_shortcuts.heading": "Ստեղնաշարի կարճատներ",
  "keyboard_shortcuts.home": "անձնական հոսքին անցնելու համար",
  "keyboard_shortcuts.hotkey": "Յատուկ ստեղն",
  "keyboard_shortcuts.legend": "այս ձեռնարկը ցուցադրելու համար",
  "keyboard_shortcuts.local": "տեղական հոսքին անցնելու համար",
  "keyboard_shortcuts.mention": "հեղինակին նշելու համար",
  "keyboard_shortcuts.muted": "լռեցուած օգտատէրերի ցանկը բացելու համար",
  "keyboard_shortcuts.my_profile": "սեփական էջին անցնելու համար",
  "keyboard_shortcuts.notifications": "ծանուցումների սիւնակը բացելու համար",
  "keyboard_shortcuts.open_media": "ցուցադրել մեդիան",
  "keyboard_shortcuts.pinned": "Բացել ամրացուած գրառումների ցանկը",
  "keyboard_shortcuts.profile": "հեղինակի անձնական էջը բացելու համար",
  "keyboard_shortcuts.reply": "պատասխանելու համար",
  "keyboard_shortcuts.requests": "հետեւելու հայցերի ցանկը դիտելու համար",
  "keyboard_shortcuts.search": "որոնման դաշտին սեւեռվելու համար",
  "keyboard_shortcuts.spoilers": "որպէսզի ցուցադրուի/թաքցուի CW դաշտը",
  "keyboard_shortcuts.start": "«սկսել» սիւնակը բացելու համար",
  "keyboard_shortcuts.toggle_hidden": "CW֊ի ետեւի տեքստը ցուցադրել֊թաքցնելու համար",
  "keyboard_shortcuts.toggle_sensitivity": "մեդիան ցուցադրել֊թաքցնելու համար",
  "keyboard_shortcuts.toot": "Նոր գրառում անելու համար",
  "keyboard_shortcuts.unfocus": "տեքստի/որոնման տիրոյթից ապասեւեռուելու համար",
  "keyboard_shortcuts.up": "ցանկով վերեւ շարժուելու համար",
  "lightbox.close": "Փակել",
  "lightbox.next": "Յաջորդ",
  "lightbox.previous": "Նախորդ",
  "lists.delete": "Ջնջել ցանկը",
  "lists.edit": "Փոփոխել ցանկը",
  "lists.replies_policy.followed": "Ցանկացած հետեւող օգտատէր",
  "lists.replies_policy.list": "Ցանկի անդամներ",
  "lists.replies_policy.none": "Ոչ ոք",
  "load_pending": "{count, plural, one {# նոր նիւթ} other {# նոր նիւթ}}",
  "navigation_bar.about": "Մասին",
  "navigation_bar.blocks": "Արգելափակուած օգտատէրեր",
  "navigation_bar.bookmarks": "Էջանիշեր",
  "navigation_bar.direct": "Մասնաւոր յիշատակումներ",
  "navigation_bar.domain_blocks": "Թաքցուած տիրոյթներ",
  "navigation_bar.favourites": "Հաւանածներ",
  "navigation_bar.filters": "Լռեցուած բառեր",
  "navigation_bar.follow_requests": "Հետեւելու հայցեր",
  "navigation_bar.followed_tags": "Հետեւած պիտակներ",
  "navigation_bar.follows_and_followers": "Հետեւածներ եւ հետեւողներ",
  "navigation_bar.lists": "Ցանկեր",
  "navigation_bar.logout": "Դուրս գալ",
  "navigation_bar.mutes": "Լռեցրած օգտատէրեր",
  "navigation_bar.preferences": "Նախապատուութիւններ",
  "navigation_bar.search": "Որոնել",
  "not_signed_in_indicator.not_signed_in": "You need to sign in to access this resource.",
  "notification.admin.sign_up": "{name}-ը գրանցուած է",
  "notification.favourite": "{name}-ը հաւանել է քո գրառումը",
  "notification.follow": "{name} սկսեց հետեւել քեզ",
  "notification.follow_request": "{name} քեզ հետեւելու հայց է ուղարկել",
  "notification.own_poll": "Հարցումդ աւարտուեց",
  "notification.reblog": "{name} տարածեց գրառումդ",
  "notification.status": "{name} հենց նոր գրառում արեց",
  "notification.update": "{name}-ը փոխել է գրառումը",
  "notifications.clear": "Մաքրել ծանուցումները",
  "notifications.clear_confirmation": "Վստա՞հ ես, որ ուզում ես մշտապէս մաքրել քո բոլոր ծանուցումները։",
  "notifications.column_settings.admin.sign_up": "Նոր գրանցումներ՝",
  "notifications.column_settings.alert": "Աշխատատիրոյթի ծանուցումներ",
  "notifications.column_settings.favourite": "Հաւանածներ՝",
  "notifications.column_settings.follow": "Նոր հետեւողներ՝",
  "notifications.column_settings.follow_request": "Նոր հետեւելու հայցեր:",
  "notifications.column_settings.mention": "Նշումներ՝",
  "notifications.column_settings.poll": "Հարցման արդիւնքները՝",
  "notifications.column_settings.push": "Հրելու ծանուցումներ",
  "notifications.column_settings.reblog": "Տարածածներից՝",
  "notifications.column_settings.show": "Ցուցադրել սիւնում",
  "notifications.column_settings.sound": "Ձայն հանել",
  "notifications.column_settings.status": "Նոր գրառումներ։",
  "notifications.column_settings.unread_notifications.category": "Չկարդացուած ծանուցումներ",
  "notifications.column_settings.update": "Խմբագրածներ՝",
  "notifications.filter.all": "Բոլորը",
  "notifications.filter.boosts": "Տարածածները",
  "notifications.filter.favourites": "Հաւանածներ",
  "notifications.filter.follows": "Հետեւածները",
  "notifications.filter.mentions": "Նշումները",
  "notifications.filter.polls": "Հարցման արդիւնքները",
  "notifications.filter.statuses": "Թարմացումներ հետեւորդներից",
  "notifications.grant_permission": "Թոյլատրել։",
  "notifications.group": "{count} ծանուցում",
  "notifications.mark_as_read": "Համարել բոլոր ծանուցումները ընթերցած",
  "notifications.permission_denied": "Աշխատատիրոյթի ծանուցումներն անհասանելի են՝ դիտարկչի նախկինում մերժուած թոյլտուութիւնների հայցման հետեւանքով",
  "notifications.permission_denied_alert": "Աշխատատիրոյթի ծանուցումները չեն կարող միացուել, քանի որ դիտարկչի թոյլտուութիւնները նախկինում մերժուել են",
  "notifications.permission_required": "Աշխատատիրոյթի ծանուցումներն անհասանելի են, քանի որ անհրաժեշտ թոյլտուութիւնները բացակայում են։",
  "notifications_permission_banner.enable": "Միացնել դիտարկչից ծանուցումները",
  "notifications_permission_banner.how_to_control": "Ծանուցումներ ստանալու համար, երբ Մաստոդոնը բաց չէ՝ ակտիւացրու աշխատատիրոյթի ծանուցումները։ Դու կարող ես ճշգրտօրէն վերահսկել թէ ինչպիսի փոխգործակցութիւններ առաջանան աշխատատիրոյթի ծանուցումներից՝ {icon}ի կոճակով՝ այն ակտիւացնելուց յետոյ։",
  "notifications_permission_banner.title": "Ոչինչ բաց մի թող",
  "picture_in_picture.restore": "Յետ բերել",
  "poll.closed": "Փակ",
  "poll.refresh": "Թարմացնել",
  "poll.total_people": "{count, plural, one {# հոգի} other {# հոգի}}",
  "poll.total_votes": "{count, plural, one {# ձայն} other {# ձայն}}",
  "poll.vote": "Քուէարկել",
  "poll.voted": "Դու քուէարկել ես այս տարբերակի համար",
  "poll.votes": "{votes, plural, one {# ձայն} other {# ձայն}}",
  "poll_button.add_poll": "Աւելացնել հարցում",
  "poll_button.remove_poll": "Հեռացնել հարցումը",
  "privacy.change": "Կարգաւորել գրառման գաղտնիութիւնը",
  "privacy.public.short": "Հրապարակային",
  "privacy_policy.last_updated": "Վերջին անգամ թարմացուել է՝ {date}",
  "privacy_policy.title": "Գաղտնիութեան քաղաքականութիւն",
  "refresh": "Թարմացնել",
  "relative_time.days": "{number}օր",
  "relative_time.full.days": "{number, plural, one {# օր} other {# օր}} առաջ",
  "relative_time.full.hours": "{number, plural, one {# ժամ} other {# ժամ}} առաջ",
  "relative_time.full.just_now": "հէնց նոր",
  "relative_time.full.minutes": "{number, plural, one {# րոպէ} other {# րոպէ}} առաջ",
  "relative_time.full.seconds": "{number, plural, one {# վայրկեան} other {# վայրկեան}} առաջ",
  "relative_time.hours": "{number}ժ",
  "relative_time.just_now": "նոր",
  "relative_time.minutes": "{number}ր",
  "relative_time.seconds": "{number}վ",
  "relative_time.today": "Այսօր",
  "reply_indicator.cancel": "Չեղարկել",
  "report.block": "Արգելափակել",
  "report.categories.other": "Այլ",
  "report.categories.spam": "Սպամ",
  "report.category.title_account": "հաշիւ",
  "report.category.title_status": "գրառում",
  "report.close": "Աւարտել",
  "report.forward": "Փոխանցել {target}֊ին",
  "report.forward_hint": "Այս հաշիւ այլ հանգոյցից է։ Ուղարկե՞մ այնտեղ էլ այս բողոքի անոնիմ պատճէնը։",
  "report.mute": "Լռեցնել",
  "report.next": "Յաջորդ",
  "report.placeholder": "Լրացուցիչ մեկնաբանութիւններ",
  "report.reasons.dislike": "Ինձ դուր չի գալիս",
  "report.reasons.other": "Այլ բան է",
  "report.reasons.spam": "Սպամ է",
  "report.submit": "Ուղարկել",
  "report.target": "Բողոքել {target}֊ի մասին",
  "report.unfollow": "Չհետեւել {name}-ին",
  "report_notification.attached_statuses": "{count, plural, one {# post} other {# posts}} attached",
  "report_notification.categories.other": "Այլ",
  "report_notification.categories.spam": "Սպամ",
  "search.no_recent_searches": "Որոնման պատմութիւն չկայ",
  "search.placeholder": "Փնտրել",
  "search.search_or_paste": "Որոնել կամ դնել URL",
  "search_popout.options": "Որոնման տեսակները",
  "search_popout.recent": "Վերջին որոնումները",
  "search_results.accounts": "Հաշիւներ",
  "search_results.all": "Բոլորը",
  "search_results.hashtags": "Պիտակներ",
  "search_results.see_all": "Տեսնել բոլորը",
  "search_results.statuses": "Գրառումներ",
  "server_banner.active_users": "ակտիւ մարդիկ",
  "server_banner.administered_by": "Կառաւարող",
  "server_banner.server_stats": "Սերուերի վիճակը",
  "sign_in_banner.create_account": "Ստեղծել հաշիւ",
  "sign_in_banner.sign_in": "Մուտք",
  "sign_in_banner.sso_redirect": "Մուտք կամ Գրանցում",
  "status.admin_account": "Բացել @{name} օգտատիրոջ մոդերացիայի դիմերէսը։",
  "status.admin_status": "Բացել այս գրառումը մոդերատորի դիմերէսի մէջ",
  "status.block": "Արգելափակել @{name}֊ին",
  "status.bookmark": "Էջանիշ",
  "status.cancel_reblog_private": "Ապատարածել",
  "status.cannot_reblog": "Այս գրառումը չի կարող տարածուել",
  "status.copy": "Պատճէնել գրառման յղումը",
  "status.delete": "Ջնջել",
  "status.detailed_status": "Շղթայի ընդլայնուած դիտում",
  "status.direct": "Մասնաւոր յիշատակում @{name}",
  "status.direct_indicator": "Մասնաւոր յիշատակում",
  "status.edit": "Խմբագրել",
  "status.edited_x_times": "Edited {count, plural, one {# time} other {# times}}",
  "status.favourite": "Հավանել",
  "status.filter": "Զտել այս գրառումը",
  "status.history.created": "{name}-ը ստեղծել է՝ {date}",
  "status.history.edited": "{name}-ը խմբագրել է՝ {date}",
  "status.load_more": "Բեռնել աւելին",
  "status.media_hidden": "մեդիաբովանդակութիւնը թաքցուած է",
  "status.mention": "Նշել @{name}֊ին",
  "status.more": "Աւելին",
  "status.mute": "Լռեցնել @{name}֊ին",
  "status.mute_conversation": "Լռեցնել խօսակցութիւնը",
  "status.open": "Ընդարձակել այս գրառումը",
  "status.pin": "Ամրացնել անձնական էջում",
  "status.read_more": "Կարդալ աւելին",
  "status.reblog": "Տարածել",
  "status.reblogged_by": "{name} տարածել է",
  "status.reblogs.empty": "Այս գրառումը ոչ մէկ դեռ չի տարածել։ Տարածողները կերեւան այստեղ, երբ տարածեն։",
  "status.redraft": "Ջնջել եւ վերակազմել",
  "status.remove_bookmark": "Հեռացնել էջանիշերից",
  "status.replied_to": "Պատասխանել է {name}-ին",
  "status.reply": "Պատասխանել",
  "status.replyAll": "Պատասխանել շղթային",
  "status.report": "Բողոքել @{name}֊ից",
  "status.sensitive_warning": "Կասկածելի բովանդակութիւն",
  "status.share": "Կիսուել",
  "status.show_less_all": "Թաքցնել բոլոր նախազգուշացնումները",
  "status.show_more_all": "Ցուցադրել բոլոր նախազգուշացնումները",
  "status.show_original": "Ցոյց տալ բնօրինակը",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Թարգմանել",
  "status.unmute_conversation": "Ապալռեցնել խօսակցութիւնը",
  "status.unpin": "Հանել անձնական էջից",
  "subscribed_languages.save": "Պահպանել փոփոխութիւնները",
  "tabs_bar.home": "Հիմնական",
  "tabs_bar.notifications": "Ծանուցումներ",
  "time_remaining.days": "{number, plural, one {մնաց # օր} other {մնաց # օր}}",
  "time_remaining.hours": "{number, plural, one {# ժամ} other {# ժամ}} անց",
  "time_remaining.minutes": "{number, plural, one {# րոպէ} other {# րոպէ}} անց",
  "time_remaining.moments": "Մնացել է մի քանի վարկեան",
  "time_remaining.seconds": "{number, plural, one {# վարկեան} other {# վարկեան}} անց",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} people}} in the past {days, plural, one {day} other {# days}}",
  "trends.trending_now": "Այժմ արդիական",
  "ui.beforeunload": "Քո սեւագիրը կը կորի, եթէ լքես Մաստոդոնը։",
  "units.short.billion": "{count}մլրդ",
  "units.short.million": "{count}մլն",
  "units.short.thousand": "{count}Հազ.",
  "upload_area.title": "Քաշիր ու նետիր՝ վերբեռնելու համար",
  "upload_button.label": "Աւելացնել մեդիա",
  "upload_error.limit": "Նիշքի վերբեռնման սահմանաչափը գերազանցուած է։",
  "upload_error.poll": "Հարցումների հետ նիշք կցել հնարաւոր չէ։",
  "upload_form.edit": "Խմբագրել",
  "upload_progress.label": "Վերբեռնվում է…",
  "upload_progress.processing": "Մշակուում է...",
  "video.close": "Փակել  տեսագրութիւնը",
  "video.download": "Ներբեռնել նիշքը",
  "video.exit_fullscreen": "Անջատել լիաէկրան դիտումը",
  "video.expand": "Ընդարձակել տեսագրութիւնը",
  "video.fullscreen": "Լիաէկրան",
  "video.hide": "Թաքցնել տեսագրութիւնը",
  "video.pause": "Դադար տալ",
  "video.play": "Նուագել"
}
